// extracted by mini-css-extract-plugin
export var component = "styles-module--component--k9pwI";
export var illustration = "styles-module--illustration--4cw85";
export var productAnim = "styles-module--product-anim--UDgrt";